import React from 'react';
import { Logo } from 'components/Logo';
import { Link } from 'components/Link/Link';

import { getConnectUrl } from 'utils';

import { type SocialLink, type Link as LinkType } from 'types';

import { getEnvironmentVariables } from 'services/environment-variables/environment-variables';
import styles from './Footer.module.scss';

interface Props {
  venueId: string | undefined;
}

export const Footer: React.FC<Props> = ({ venueId }) => {
  const { SUPPORT_GUIDE_URL } = getEnvironmentVariables();
  const socials: SocialLink[] = [
    {
      url: 'https://www.facebook.com/doshiiAU/',
      iconName: 'facebook'
    },
    {
      url: 'https://www.instagram.com/doshii_au/',
      iconName: 'instagram'
    },
    {
      url: 'https://www.linkedin.com/company/doshii/?originalSubdomain=au',
      iconName: 'linkedin'
    },
    {
      url: 'https://twitter.com/Doshii_au',
      iconName: 'twitter'
    }
  ];

  const footerLinks: LinkType[] = [
    {
      url: SUPPORT_GUIDE_URL,
      label: 'Doshii Guide'
    },
    {
      url: 'https://doshii.com/en-au/privacy-policy',
      label: 'Privacy Policy'
    },
    {
      url: 'https://doshii.com/en-au/merchant-terms',
      label: 'Merchant Terms'
    }
  ];

  const linksJsx = (
    <ul className={styles.Links}>
      {footerLinks.map(({ url, label }: LinkType) => {
        return (
          <li key={url}>
            <Link target="_blank" href={url}>
              {label}
            </Link>
          </li>
        );
      })}
    </ul>
  );

  return (
    <footer className={styles.Footer}>
      <div className="container">
        <div>
          <a
            href={getConnectUrl(venueId)}
            aria-label="doshii-connect"
            data-testid="footer-logo"
            className={styles.Logo}
          >
            <Logo disableMobileLogo />
          </a>
          {linksJsx}
        </div>
        <div>
          <ul className={styles.Socials}>
            {socials.map(({ url, iconName }: SocialLink) => {
              return (
                <li key={url}>
                  <a href={url} aria-label={iconName}>
                    <i className={`mm-${iconName}`} />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div>{linksJsx}</div>
      </div>
    </footer>
  );
};
